import { render, staticRenderFns } from "./SSSContributionDetails.vue?vue&type=template&id=4c012d35&scoped=true"
import script from "./SSSContributionDetails.vue?vue&type=script&lang=js"
export * from "./SSSContributionDetails.vue?vue&type=script&lang=js"
import style0 from "./SSSContributionDetails.vue?vue&type=style&index=0&id=4c012d35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c012d35",
  null
  
)

export default component.exports